import React from 'react';
import {
    FormControlProps,
    InputLabel,
    FormControl as MuiFormControl,
    OutlinedInput as MuiOutlinedInput,
} from '@material-ui/core';
import styled from 'styled-components';

interface AdornedSimpleInputProps {
    name: string;
    value: string | null;
    onChange(v: string): void;
    placeholder?: string;
    margin?: FormControlProps['margin'];
    required?: boolean;
    label?: string;
    endAdornment: React.ReactNode;
}

const OutlinedInput = styled(MuiOutlinedInput)`
    &{
        .MuiOutlinedInput-inputAdornedEnd {
            padding-right: 0;
        }
        ${({ theme }) => `
            .MuiOutlinedInput-input {
                padding: ${theme.spacing(1.375)}px ${theme.spacing(1.5)}px;
            }
        `}
    }
`;

const FormControl = styled(({ label, ...props }: FormControlProps & { label?: string }) => <MuiFormControl {...props} />)`
    .MuiInputAdornment-root {
        z-index: 1;
    }
    .MuiInputBase-root {
        background-color: #ffffff;
    }
    fieldset {
        ${({ label }) => label
        ? ``
        : `
            &.MuiOutlinedInput-notchedOutline {
                top: 0;
            }
        `}
        legend > * {
            display: none;
        }
    }
    .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
        border-color: rgba(0, 0, 0, 0.23);
    }
    ${({ theme }) => `
        .MuiInputLabel-outlined.MuiInputLabel-shrink {
            z-index: 0;
            transform: translate(${theme.spacing(1)}px, 0px) scale(0.75);
        }
        .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-width: 1px;
            border-color: ${theme.palette.primary.main};
        }
    `}
    ${({ label, theme }) => label
        ? `
            .MuiFormLabel-root + * {
                margin-top: ${theme.spacing(2.25)}px;
            }
        `
        : ``}
`;



const AdornedSimpleInput = ({
    label,
    value,
    required,
    placeholder,
    margin = 'normal',
    onChange,
    name,
    endAdornment,
}: AdornedSimpleInputProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        onChange(event.target.value);
    };

    return (
        <FormControl label={label} variant='outlined' fullWidth margin={margin} required={required}>
            {label
                ? (
                    <InputLabel shrink htmlFor={name}>
                        {label}
                    </InputLabel>
                ): null}
            <OutlinedInput
                id={name}
                value={value}
                label={label}
                placeholder={placeholder}
                onChange={handleChange}
                endAdornment={endAdornment}
            />
        </FormControl>
    );
};

export default AdornedSimpleInput;
